import type { PluginKeyFormValues, PluginKeyPayload } from '../types'
import { parseWebsites } from './websites'

/**
 * Form values → API payload. The environment is part of the key, so it is only
 * sent when creating; an edit leaves it out.
 */
export const toPluginKeyPayload = (
  values: PluginKeyFormValues,
  mode: 'create' | 'edit'
): PluginKeyPayload => ({
  name: values.name.trim(),
  ...(mode === 'create' ? { environment: values.environment } : {}),
  allowed_origins: parseWebsites(values.websites),
  allow_sandboxed: values.allowSandboxed,
})
